import React from "react";
import { Modal, StyleSheet, TouchableOpacity, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import DeliveryCodeNotGenerated from "./DeliveryCodeNotGenerated";

const DeliveryCodeModal = ({
  visible,
  setVisible,
  spokeDeliveryReturnDetails,
}) => {
  const insets = useSafeAreaInsets();
  const { deliveryBoyInfo } =
    spokeDeliveryReturnDetails?.deliveryDetails ||
    spokeDeliveryReturnDetails?.returnDetails ||
    {};

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      transparent={true}
      visible={visible}
    >
      <View style={{ flex: 1 }}>
        <TouchableOpacity
          testID="dcm-close"
          onPress={() => setVisible(false)}
          style={{ backgroundColor: "rgba(0,0,0,0.4)", flex: 1 }}
        />
        <View
          style={[styles.modalWrapper, { paddingBottom: 5 + insets.bottom }]}
        >
          {deliveryBoyInfo && (
            <DeliveryCodeNotGenerated deliveryBoyInfo={deliveryBoyInfo} />
          )}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalWrapper: {
    backgroundColor: "white",
    flex: 1,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    width: "100%",
    padding: 5,
    position: "absolute",
    bottom: 0,
    minHeight: 300,
  },
});

export default DeliveryCodeModal;
